import { QuestionCircleOutlined } from '@ant-design/icons';
import { useI18n } from '@/i18n/useI18n';

/**
 * The F-IS-08 anti-abandonment feature: a plain-language "why we ask" for every task, always visible.
 * Applicants abandon when a request feels arbitrary or intrusive; naming the reason keeps them moving.
 */
export function WhyWeAsk({ text }: { text: string }) {
  const { t } = useI18n();
  return (
    <div className="dr-why">
      <QuestionCircleOutlined className="dr-why__icon" aria-hidden="true" />
      <div className="dr-why__body">
        <div className="dr-why__label">{t('tasks.whyLabel')}</div>
        <div className="dr-why__text">{text}</div>
      </div>
    </div>
  );
}
